<template>
    <div>
        <van-search placeholder="出库单号或明细码(自动去杠)搜索" v-model="value" @search="selectValue()"/>
        <div>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
        
                <div style="border-top: 0.5px solid #333333;">
                    <div class="each" v-for="(i,item) in list" :key="item">
                        <div class="each-id">{{item+1}}</div>
                        <div class="each-number" @click="go_FGurl(i.id , i.type)">{{i.out_num}}</div>
                        <div class="each-jms">{{i.status}}</div>
                        <div class="each-cz">
                            <div class="cz-size" @click="deleteFG(i.id,item)" style="color: white;background-color: red">
                                <van-icon name="close" size="0.5rem" style="color: white"/>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
  import { Dialog } from "vant";
  import { Toast } from 'vant';
  export default {
    name: "OutList",
    data(){
      return{
        value:'',
        list: [],
        loading: false,
        finished: false,
        page:1,
          username:""
      }
    },
    mounted(){
        this.username = JSON.parse(window.localStorage.getItem("userinfo"))
    },
    methods: {
      async getdata(){
        if(this.value.indexOf('-') !== -1){
          // 有杠
          this.value = this.value.substr(0 , this.value.indexOf('-'))
        }
        let data={
          page:this.page,
          reel:'',
          gck_number:this.value
        }
        let packing = await this.get(this.APIOBJ.out_List,data)
        let dataObj = {}
        packing.data.data.data.forEach(item =>{
          if(typeof dataObj[item.id] === 'undefined'){
            dataObj[item.id] = item
          }
        })
        let array = []
        for(let key in dataObj){
          array.unshift(dataObj[key])
        }
        array.map((i)=>{
          this.list.push(i)
        })
        if(packing.data.data.data.length === 0){
          this.finished = true;
        }
      },
      onLoad() {
        // 异步更新数据
        setTimeout(() => {
          this.getdata()
          // 加载状态结束
          this.page ++
          this.loading = false;
        }, 500);
      },
      selectValue(){
        this.list=[]
        this.page=1
        this.onLoad()
      },
      deleteFG(id,item){
        Dialog.confirm({
          message: "确定删除吗？"
        }).then( async () => {
          let packing = await this.get(this.APIOBJ.outDel,{id , username:this.username})
          if(packing.data.status === 1){
            this.list.splice(item,1)
          }
          Toast(packing.data.msg)
        });
      },
      go_FGurl(id , type){
        // this.$router.push({path:'/orderInfo',query:{id}});
        if(type === null){
          type = 'orderInfo'
        }
        this.$router.push({path:`/${type}`,query:{id}})
        setTimeout(() => {
          window.location.reload()
        }, 100);
      }
    }
  }
</script>

<style lang="less">
.each{
    display: flex;
    margin: 5px 0;
    padding: 5px 0;
    border-bottom: 0.5px solid #333333;
}
    .each-id{
        width: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .each-number{
        width: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: underline;
    }
    .each-jms{
        width: 4.1rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .each-cz{
        display: flex;
        justify-content: space-between;
        width: 1.5rem;
    }
    .cz-size{
        width: 0.7rem;
        height: 0.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>